module.exports = __webpack_public_path__ + "static/img/first-rank-bg.bd2541e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-template/first-rank-bg.png
// module id = xQ6i
// module chunks = 216